import { AlphaNumeric } from './alphaNumeric.directive';
import { OnlyNumber } from './onlyNumber.directive';
import { AutoFocus } from './autoFocus.directive';

export const APP_DIRECTIVES: any[] = [
	AlphaNumeric,
	OnlyNumber,
	AutoFocus
];

export * from './alphaNumeric.directive';
export * from './onlyNumber.directive';
export * from './autoFocus.directive';


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/common/directive/index.ts